import { useSelector } from 'src/store';
import { productVersionSelector } from 'src/store/selectors/productSelector';

function Footer() {
  const productVersion = useSelector(productVersionSelector);

  return (
    <footer className="py-5">
      <p className="is-size-5 has-text-centered">{`Data Transformation v${productVersion}`}</p>
    </footer>
  );
}

export default Footer;
